import { render, staticRenderFns } from "./UatTestSendView.vue?vue&type=template&id=81628518&scoped=true"
import script from "./UatTestSendView.vue?vue&type=script&lang=js"
export * from "./UatTestSendView.vue?vue&type=script&lang=js"
import style0 from "./UatTestSendView.vue?vue&type=style&index=0&id=81628518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81628518",
  null
  
)

export default component.exports